import { useEffect } from 'react';
import './SessionExtension.css';
import { useTranslation } from "react-i18next";

export default function SessionExtension({closeSelected}) {
    const {t} = useTranslation();


    return (
        <>
            <div className="session-container">
                <strong>{t('continueChatPrompt')}</strong>

                <div className="session-btn-container">
                    <button onClick={() => closeSelected(false)} className="session-btn session-btn-main">
                        {t('continueChat')}
                    </button>
                    <button onClick={() => closeSelected(true)} className="session-btn">
                        {t('endChat')}
                    </button>
                </div>
            </div>
        </>

    )
}
